import { unified } from 'unified'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import rehypeStringify from 'rehype-stringify'
import { visit } from 'unist-util-visit'
import type { Element, Root } from 'hast'

// Tags that should have their inherited styles reverted when embedded in host markup (e.g. emails)
const TAGS_TO_REVERT_STYLE = new Set(['hr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'li', 'ol', 'code'])

function rehypeRevertStyles() {
  return (tree: Root) => {
    visit(tree, 'element', (node: Element) => {
      if (TAGS_TO_REVERT_STYLE.has(node.tagName)) {
        node.properties = { ...node.properties, style: 'all: revert' }
      }
    })
  }
}

/**
 * Converts Markdown text to an HTML string and reverts all inherited styles.
 * Pure string processing (no DOM/react-dom), safe to run in both server and browser code.
 * @param markdown - The Markdown string to convert.
 * @returns The HTML string representation of the Markdown content.
 */
export default function getHtmlFromMarkdown(markdown: string) {
  const file = unified()
    .use(remarkParse)
    .use(remarkRehype)
    .use(rehypeRevertStyles)
    .use(rehypeStringify)
    .processSync(markdown)

  return String(file)
}
